import React, { useEffect, useMemo, useState } from 'react';
import { EXPERIENCE_DATA } from '../../data/experience';

const ExperienceApp = () => {
  const [activeCompanyIndex, setActiveCompanyIndex] = useState(0);
  const [activeRoleIndex, setActiveRoleIndex] = useState(0);

  const activeCompany = useMemo(
    () => EXPERIENCE_DATA[activeCompanyIndex] || EXPERIENCE_DATA[0],
    [activeCompanyIndex]
  );

  const activeRole = activeCompany.roles[activeRoleIndex] || activeCompany.roles[0];

  useEffect(() => {
    setActiveRoleIndex(0);
  }, [activeCompanyIndex]);

  return (
    <div className="experience-route-shell">
      <div className="experience-route-header">
        <div>
          <p className="experience-route-kicker">Experience</p>
          <h2 className="experience-route-title">A route map of how the work evolved.</h2>
          <p className="experience-route-copy">
            Each stop is a different chapter of the same story: build useful systems, make them reliable, and keep pushing the edges of what they can do.
          </p>
        </div>
        <div className="experience-route-metric">
          <span className="experience-route-metric-value">{EXPERIENCE_DATA.length}</span>
          <span className="experience-route-metric-label">career stops</span>
        </div>
      </div>

      <div className="experience-route-layout">
        <div className="experience-route-rail-wrapper">
          <div className="experience-route-rail">
            <div className="experience-route-rail-line" aria-hidden="true" />
            {EXPERIENCE_DATA.map((company, companyIndex) => {
              const isActive = companyIndex === activeCompanyIndex;
              return (
                <button
                  key={company.company}
                  type="button"
                  className={`experience-route-stop${isActive ? ' active' : ''}`}
                  onClick={() => setActiveCompanyIndex(companyIndex)}
                >
                  <span className="experience-route-stop-index">0{companyIndex + 1}</span>
                  <span className="experience-route-stop-dot" />
                  <span className="experience-route-stop-copy">
                    <span className="experience-route-stop-company">{company.company}</span>
                    <span className="experience-route-stop-role-count">{company.roles.length} role{company.roles.length !== 1 ? 's' : ''}</span>
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="experience-route-panel">
          <div className="experience-route-panel-head">
            <div>
              <p className="experience-route-panel-company">{activeCompany.company}</p>
              <h3 className="experience-route-panel-title">{activeRole.title}</h3>
            </div>
            <span className="experience-route-panel-period">{activeRole.period}</span>
          </div>

          <div className="experience-route-role-tabs">
            {activeCompany.roles.map((role, roleIndex) => {
              const isActive = roleIndex === activeRoleIndex;
              return (
                <button
                  key={`${role.title}-${roleIndex}`}
                  type="button"
                  className={`experience-route-role-tab${isActive ? ' active' : ''}`}
                  onClick={() => setActiveRoleIndex(roleIndex)}
                >
                  <span className="experience-route-role-tab-index">{roleIndex + 1}</span>
                  <span className="experience-route-role-tab-copy">
                    <span className="experience-route-role-tab-title">{role.title}</span>
                    <span className="experience-route-role-tab-period">{role.period}</span>
                  </span>
                </button>
              );
            })}
          </div>

          <div className="experience-route-story">
            <p>{activeRole.narrative}</p>
          </div>

          <div className="experience-route-skill-grid">
            {activeRole.skills.map((skill) => (
              <span key={skill} className="experience-route-skill-pill">{skill}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExperienceApp;
